import { render, staticRenderFns } from "./SalesReports.vue?vue&type=template&id=1a6e258a&scoped=true&"
import script from "./SalesReports.vue?vue&type=script&lang=js&"
export * from "./SalesReports.vue?vue&type=script&lang=js&"
import style0 from "./SalesReports.vue?vue&type=style&index=0&id=1a6e258a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6e258a",
  null
  
)

export default component.exports